(() => {
  "use strict";

  const root = document.getElementById("dirt-smk");
  if (!root || root.dataset.initialized === "true") return;
  root.dataset.initialized = "true";

  const stage = root.querySelector("#dirt-smk-stage");
  const progress = root.querySelector("#dirt-smk-progress");
  const barTitle = root.querySelector("#dirt-smk-title");
  const priceFormatter = new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
  });

  const icons = {
    white:
      '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M13 6h22l-2.2 16.4A9 9 0 0 1 24 30a9 9 0 0 1-8.8-7.6L13 6Z" fill="#f2cf65" stroke="currentColor" stroke-width="2.5"/><path d="M24 30v10M17 42h14" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2.5"/></svg>',
    red:
      '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M13 6h22l-2.2 16.4A9 9 0 0 1 24 30a9 9 0 0 1-8.8-7.6L13 6Z" fill="#a92f32" stroke="currentColor" stroke-width="2.5"/><path d="M24 30v10M17 42h14" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2.5"/></svg>',
    rose:
      '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M13 6h22l-2.2 16.4A9 9 0 0 1 24 30a9 9 0 0 1-8.8-7.6L13 6Z" fill="#ed9fa1" stroke="currentColor" stroke-width="2.5"/><path d="M24 30v10M17 42h14" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2.5"/></svg>',
    orange:
      '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M13 6h22l-2.2 16.4A9 9 0 0 1 24 30a9 9 0 0 1-8.8-7.6L13 6Z" fill="#dc7a37" stroke="currentColor" stroke-width="2.5"/><path d="M24 30v10M17 42h14" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2.5"/></svg>',
    bubbles:
      '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="m18 6 1.8 23h8.4L30 6H18Z" fill="#f0d87d" stroke="currentColor" stroke-width="2.5"/><path d="M24 29v11M18 42h12M21 12h.1M27 17h.1M23 22h.1" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2.5"/></svg>',
    surprise:
      '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M10 15 24 7l14 8v18l-14 8-14-8V15Z" fill="#c9a7f0" stroke="currentColor" stroke-linejoin="round" stroke-width="2.5"/><path d="m10 15 14 8 14-8M24 23v18" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="2.5"/><circle cx="18" cy="17" r="1.7" fill="currentColor"/><circle cx="30" cy="17" r="1.7" fill="currentColor"/><circle cx="17" cy="29" r="1.7" fill="currentColor"/><circle cx="31" cy="29" r="1.7" fill="currentColor"/></svg>',
  };

  const questions = [
    {
      id: "color",
      title: "Welke kleur <em>lonkt?</em>",
      subtitle: "Kies wat je nu het liefst inschenkt.",
      options: [
        { id: "wit", label: "Wit", sub: "fris of vol", icon: icons.white, color: "wit" },
        { id: "rood", label: "Rood", sub: "sappig of stevig", icon: icons.red, color: "rood" },
        { id: "rose", label: "Rosé", sub: "fruitig en los", icon: icons.rose, color: "rose" },
        { id: "oranje", label: "Oranje", sub: "spannend en gelaagd", icon: icons.orange, color: "oranje" },
        { id: "bubbels", label: "Bubbels", sub: "feestelijk en fris", icon: icons.bubbles, color: "bubbels" },
        { id: "verras", label: "Verras me", sub: "alles mag", icon: icons.surprise, color: "any" },
      ],
    },
    {
      id: "body",
      title: "Hoe mag je wijn <em>voelen?</em>",
      subtitle: "Ga af op je eerste ingeving.",
      textOnly: true,
      options: [
        { id: "licht", label: "Lichtvoetig", sub: "fris, soepel", set: { w: 0.24, t: 0.18 } },
        { id: "midden", label: "Mooi ertussenin", sub: "rond, in balans", set: { w: 0.52, t: 0.38 } },
        { id: "vol", label: "Lekker vol", sub: "rijk, krachtig", set: { w: 0.84, t: 0.64 } },
      ],
    },
    {
      id: "coffee",
      title: "Wat bestel je na <em>het eten?</em>",
      subtitle: "Je koffiekeuze zegt stiekem best veel.",
      textOnly: true,
      options: [
        { id: "espresso", label: "Espresso, puur", sub: "krachtig, bitter", add: { w: 0.14, t: 0.12, ok: 0.16 } },
        { id: "cappuccino", label: "Cappuccino", sub: "zacht, romig", add: { w: 0.1, a: -0.08, tr: 0.12 } },
        { id: "thee", label: "Thee of iets fris", sub: "licht, aromatisch", add: { w: -0.12, a: 0.13, fl: 0.12 } },
      ],
    },
    {
      id: "dish",
      title: "Welk gerecht trekt je nu <em>het meest?</em>",
      subtitle: "Kies je ideale bord.",
      textOnly: true,
      twoColumns: true,
      options: [
        { id: "steak", label: "Gegrilde steak / wild", sub: "vlezig, hartig", add: { w: 0.16, t: 0.2, fr: 0.12, ok: 0.1 } },
        { id: "oysters", label: "Oesters / sushi", sub: "fris, zilt", add: { w: -0.14, a: 0.18, ci: 0.18, se: 0.2 } },
        { id: "cheese", label: "Rijpe kaasplank", sub: "vol, umami", add: { w: 0.14, tr: 0.12, se: 0.16 } },
        { id: "spicy", label: "Pittig Aziatisch", sub: "kruidig, spannend", add: { a: 0.08, s: 0.1, fl: 0.2, fr: 0.08 } },
        { id: "summer", label: "Zomers fruit op ’t terras", sub: "licht, fruitig", add: { w: -0.16, a: 0.1, fr: 0.2, ci: 0.1 } },
        { id: "dessert", label: "Iets zoets toe", sub: "fruit & honing", add: { s: 0.24, fr: 0.13, tr: 0.2 } },
      ],
    },
    {
      id: "flavors",
      title: "Welke smaken <em>trekken je?</em>",
      subtitle: "Kies één of twee smaken.",
      textOnly: true,
      twoColumns: true,
      multiple: true,
      min: 1,
      max: 2,
      options: [
        { id: "savory", label: "Olijven & ansjovis", sub: "hartig, zilt", add: { se: 0.34 } },
        { id: "redfruit", label: "Rijp rood fruit", sub: "kers, framboos", add: { fr: 0.34 } },
        { id: "citrus", label: "Citrus & groene appel", sub: "fris, knisperend", add: { ci: 0.34, a: 0.08 } },
        { id: "apricot", label: "Abrikoos & honing", sub: "zonnig, rijp", add: { tr: 0.3, fr: 0.1 } },
        { id: "vanilla", label: "Vanille & geroosterd", sub: "rond, warm", add: { ok: 0.34, w: 0.08 } },
        { id: "flowers", label: "Bloemen & kruiden", sub: "aromatisch", add: { fl: 0.34 } },
      ],
    },
    {
      id: "sweetness",
      title: "Hoe droog wil je <em>drinken?</em>",
      subtitle: "Van strakdroog tot een tikje zoet.",
      textOnly: true,
      options: [
        { id: "dry", label: "Strakdroog", sub: "fris, precies", set: { s: 0.02 }, add: { a: 0.1 } },
        { id: "softdry", label: "Zacht droog", sub: "rond, soepel", set: { s: 0.12 }, add: { w: 0.08 } },
        { id: "offdry", label: "Een tikje zoet", sub: "rijp, gul", set: { s: 0.42 }, add: { fr: 0.1, tr: 0.1 } },
      ],
    },
    {
      id: "budget",
      title: "Wat mag de fles <em>kosten?</em>",
      subtitle: "We houden rekening met je budget.",
      textOnly: true,
      options: [
        { id: "a", label: "Tot €10", sub: "lekker laagdrempelig" },
        { id: "b", label: "€10 tot €15", sub: "net wat bijzonderder" },
        { id: "c", label: "€15 en meer", sub: "ik wil iets speciaals" },
        { id: "x", label: "Prijs maakt niet uit", sub: "toon mijn beste match" },
      ],
    },
  ];

  const state = {
    step: 0,
    answers: {},
    wines: [],
    started: false,
    result: null,
  };

  const traitKeys = ["w", "a", "t", "s", "fr", "ci", "fl", "se", "ok", "tr"];
  const baseTraits = { w: 0.5, a: 0.52, t: 0.34, s: 0.08, fr: 0.28, ci: 0.28, fl: 0.2, se: 0.14, ok: 0.16, tr: 0.2 };

  function normalizeText(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();
  }

  function stripHtml(value) {
    const documentFragment = new DOMParser().parseFromString(String(value || ""), "text/html");
    return documentFragment.body.textContent || "";
  }

  function escapeHtml(value) {
    return String(value ?? "").replace(/[&<>"']/g, (character) => {
      const entities = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" };
      return entities[character];
    });
  }

  function clamp(value) {
    return Math.max(0, Math.min(1, value));
  }

  function track(event, parameters = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...parameters });
  }

  function arrowIcon(direction = "right") {
    const path = direction === "left" ? "M15 4 7 12l8 8M8 12h13" : "m9 4 8 8-8 8m7-8H3";
    return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${path}"/></svg>`;
  }

  function imageUrl(source, width) {
    try {
      const url = new URL(source, window.location.origin);
      url.searchParams.set("width", String(width));
      return url.toString();
    } catch {
      return source;
    }
  }

  function productImage(wine, widths, sizes, className = "") {
    const sources = widths.map((width) => `${escapeHtml(imageUrl(wine.image.src, width))} ${width}w`).join(", ");
    const width = Number(wine.image.width) || 800;
    const height = Number(wine.image.height) || 1000;
    return `<img class="${className}" src="${escapeHtml(imageUrl(wine.image.src, widths[0]))}" srcset="${sources}" sizes="${escapeHtml(sizes)}" alt="${escapeHtml(wine.image.alt || wine.title)}" width="${width}" height="${height}" loading="${widths[0] > 500 ? "eager" : "lazy"}">`;
  }

  function pickBottleVariant(product) {
    const variants = Array.isArray(product.variants) ? product.variants.filter((variant) => variant.available) : [];
    return (
      variants.find((variant) => /^(fles|bottle|default title)$/i.test(String(variant.title || "").trim())) ||
      variants.find((variant) => !/(doos|box|case|6-pack|12-pack)/i.test(String(variant.title || ""))) ||
      variants[0]
    );
  }

  function detectColor(text) {
    if (/(mousserend|bubbel|pet nat|pet-nat|cremant|champagne|prosecco|spumante|brut|metodo classico)/.test(text)) return "bubbels";
    if (/(orange wine|oranje|skin contact|schilweking|maceratie)/.test(text)) return "oranje";
    if (/(rose|rosado|rosato)/.test(text)) return "rose";
    if (/(rode wijn|rood|rouge|tinto|rosso|red wine)/.test(text)) return "rood";
    if (/(witte wijn|wit|blanc|bianco|blanco|white wine)/.test(text)) return "wit";
    return "any";
  }

  function vectorize(text, color) {
    const colorBases = {
      wit: { w: 0.35, a: 0.68, t: 0.08, s: 0.07, fr: 0.28, ci: 0.58, fl: 0.28, se: 0.18, ok: 0.12, tr: 0.26 },
      rood: { w: 0.68, a: 0.46, t: 0.68, s: 0.05, fr: 0.62, ci: 0.12, fl: 0.25, se: 0.16, ok: 0.24, tr: 0.16 },
      rose: { w: 0.36, a: 0.63, t: 0.13, s: 0.08, fr: 0.62, ci: 0.35, fl: 0.2, se: 0.14, ok: 0.05, tr: 0.18 },
      oranje: { w: 0.58, a: 0.55, t: 0.4, s: 0.06, fr: 0.28, ci: 0.32, fl: 0.42, se: 0.28, ok: 0.12, tr: 0.52 },
      bubbels: { w: 0.25, a: 0.8, t: 0.06, s: 0.08, fr: 0.26, ci: 0.58, fl: 0.22, se: 0.15, ok: 0.08, tr: 0.2 },
      any: { ...baseTraits },
    };
    const traits = { ...(colorBases[color] || colorBases.any) };
    const rules = [
      [/(licht|fris|slank|elegant|delicaat|mineraal|mineral)/, { w: -0.2, a: 0.15, t: -0.13 }],
      [/(vol|rijk|krachtig|stevig|intens|opulent|body)/, { w: 0.2, t: 0.14 }],
      [/(zacht|rond|soepel|romig|creamy)/, { w: 0.1, a: -0.1, t: -0.08 }],
      [/(strak|knisperend|levendig|zuur|acidity|fresh)/, { a: 0.16, w: -0.08 }],
      [/(tannine|tannic|structuur|structure)/, { t: 0.2 }],
      [/(zoet|sweet|moelleux|doux|demi-sec|restsuiker)/, { s: 0.28 }],
      [/(droog|dry|sec|brut nature|zero dosage)/, { s: -0.08 }],
      [/(kers|framboos|aardbei|braam|bes|pruim|rood fruit|zwart fruit|berry|cherry|raspberry)/, { fr: 0.26 }],
      [/(citrus|citroen|limoen|grapefruit|groene appel|green apple|lemongrass)/, { ci: 0.27, a: 0.05 }],
      [/(bloem|floral|violet|roos|jasmijn|kruid|herb|tijm|peper|specerij)/, { fl: 0.26 }],
      [/(zilt|salin|olijf|ansjovis|umami|aards|earthy|leer|tabak)/, { se: 0.27 }],
      [/(vanille|toast|geroosterd|hout|oak|eiken|koffie|cacao|chocolade|rook)/, { ok: 0.28, w: 0.05 }],
      [/(abrikoos|perzik|honing|tropisch|mango|ananas|rijp fruit|steenfruit|stone fruit)/, { tr: 0.28, fr: 0.07 }],
    ];
    rules.forEach(([pattern, additions]) => {
      if (!pattern.test(text)) return;
      Object.entries(additions).forEach(([key, value]) => {
        traits[key] = clamp(traits[key] + value);
      });
    });
    return traits;
  }

  function normalizeProduct(product) {
    const variant = pickBottleVariant(product);
    const image = Array.isArray(product.images) ? product.images[0] : product.image;
    if (!variant || !image?.src || !product.handle) return null;
    const tags = Array.isArray(product.tags) ? product.tags.join(" ") : product.tags || "";
    const text = normalizeText([product.title, product.vendor, product.product_type, tags, stripHtml(product.body_html)].join(" "));
    const color = detectColor(text);
    return {
      handle: product.handle,
      title: product.title,
      vendor: product.vendor || "DIRT.",
      url: `${root.dataset.collectionUrl}/products/${encodeURIComponent(product.handle)}`.replace(/\/collections\/[^/]+\/products/, "/products"),
      variantId: variant.id,
      price: Number(variant.price),
      image: {
        src: image.src,
        alt: image.alt || product.title,
        width: image.width,
        height: image.height,
      },
      color,
      traits: vectorize(text, color),
    };
  }

  function selected(question) {
    return state.answers[question.id] || [];
  }

  function selectedOptions(question) {
    const chosen = new Set(selected(question));
    return question.options.filter((option) => chosen.has(option.id));
  }

  function buildTarget() {
    const traits = { ...baseTraits };
    let color = "any";
    questions.forEach((question) => {
      selectedOptions(question).forEach((option) => {
        if (option.color) color = option.color;
        if (option.set) {
          Object.entries(option.set).forEach(([key, value]) => {
            traits[key] = value;
          });
        }
        if (option.add) {
          Object.entries(option.add).forEach(([key, value]) => {
            traits[key] = clamp(traits[key] + value);
          });
        }
      });
    });
    traitKeys.forEach((key) => {
      traits[key] = clamp(traits[key]);
    });
    return {
      color,
      budget: selected(questions[6])[0] || "x",
      traits,
      flavors: selected(questions[4]),
    };
  }

  function inBudget(price, budget) {
    if (budget === "a") return price < 10;
    if (budget === "b") return price >= 10 && price <= 15;
    if (budget === "c") return price > 15;
    return true;
  }

  function rankWines() {
    const target = buildTarget();
    const sameColor = target.color === "any" ? state.wines : state.wines.filter((wine) => wine.color === target.color);
    const colorCandidates = sameColor.length ? sameColor : state.wines;
    const onBudget = colorCandidates.filter((wine) => inBudget(wine.price, target.budget));
    const candidates = onBudget.length >= 4 ? onBudget : colorCandidates;
    const flavorMap = { savory: "se", redfruit: "fr", citrus: "ci", apricot: "tr", vanilla: "ok", flowers: "fl" };
    const scored = candidates.map((wine) => {
      let score = 0;
      const weights = { w: 1.25, a: 1.15, t: 1.05, s: 1.2, fr: 0.62, ci: 0.62, fl: 0.62, se: 0.62, ok: 0.62, tr: 0.62 };
      traitKeys.forEach((key) => {
        score -= Math.abs(target.traits[key] - wine.traits[key]) * weights[key];
      });
      target.flavors.forEach((flavor) => {
        score += wine.traits[flavorMap[flavor]] * 0.72;
      });
      if (inBudget(wine.price, target.budget)) score += 0.45;
      if (target.color !== "any" && wine.color === target.color) score += 1.4;
      return { ...wine, score };
    });
    scored.sort((a, b) => b.score - a.score);
    const result = scored[0];
    const alternatives = [];
    const vendors = new Set(result ? [normalizeText(result.vendor)] : []);
    scored.slice(1).forEach((wine) => {
      if (alternatives.length >= 3) return;
      const vendor = normalizeText(wine.vendor);
      if (!vendors.has(vendor)) {
        alternatives.push(wine);
        vendors.add(vendor);
      }
    });
    scored.slice(1).forEach((wine) => {
      if (alternatives.length >= 3 || alternatives.some((item) => item.handle === wine.handle)) return;
      alternatives.push(wine);
    });
    return result ? { match: result, alternatives, target } : null;
  }

  function optionLabel(questionId, optionId) {
    const question = questions.find((item) => item.id === questionId);
    return question?.options.find((option) => option.id === optionId)?.label || "";
  }

  function profileLabels() {
    const labels = [
      optionLabel("color", selected(questions[0])[0]),
      optionLabel("body", selected(questions[1])[0]),
      ...selected(questions[4]).map((id) => optionLabel("flavors", id)),
      optionLabel("sweetness", selected(questions[5])[0]),
    ];
    return labels.filter(Boolean).slice(0, 4);
  }

  function sentenceList(values) {
    if (values.length < 2) return values[0] || "jouw smaak";
    if (values.length === 2) return `${values[0]} en ${values[1]}`;
    return `${values.slice(0, -1).join(", ")} en ${values.at(-1)}`;
  }

  function renderProgress(index, complete = false) {
    progress.innerHTML = questions
      .map((question, step) => {
        const status = complete || step < index ? " is-done" : step === index ? " is-current" : "";
        return `<span class="smk__progress-step${status}" aria-hidden="true"></span>`;
      })
      .join("");
    progress.setAttribute("aria-valuenow", String(complete ? questions.length : index + 1));
    progress.setAttribute("aria-valuetext", complete ? "Smaaktest voltooid" : `Vraag ${index + 1} van ${questions.length}`);
  }

  function focusHeading() {
    window.requestAnimationFrame(() => {
      stage.querySelector("[data-view-heading]")?.focus({ preventScroll: true });
    });
  }

  function renderQuestion() {
    const question = questions[state.step];
    const chosen = selected(question);
    barTitle.textContent = `Vraag ${state.step + 1} / ${questions.length}`;
    renderProgress(state.step);
    const navigation =
      state.step === 0
        ? `<a class="smk__shop-link" href="${escapeHtml(root.dataset.collectionUrl)}">${arrowIcon("left")} Alle wijnen</a>`
        : `<button class="smk__back" type="button" data-back>${arrowIcon("left")} Terug</button>`;
    const optionClasses = ["smk__opts", question.textOnly ? "smk__opts--text" : "", question.twoColumns ? "smk__opts--two" : ""]
      .filter(Boolean)
      .join(" ");
    const options = question.options
      .map((option) => {
        const active = chosen.includes(option.id);
        return `<button class="smk__opt" type="button" data-option="${escapeHtml(option.id)}" aria-pressed="${active}">
          ${option.icon ? `<span class="smk__opt-icon">${option.icon}</span>` : ""}
          <span class="smk__opt-label">${escapeHtml(option.label)}</span>
          ${option.sub ? `<span class="smk__opt-sub">${escapeHtml(option.sub)}</span>` : ""}
        </button>`;
      })
      .join("");
    const minimum = question.min || 1;
    const canContinue = chosen.length >= minimum;
    const continueCopy = question.multiple ? (chosen.length ? `Verder (${chosen.length} van ${question.max})` : "Kies één of twee smaken") : "Verder";
    stage.innerHTML = `<div class="smk__view">
      ${navigation}
      <h2 class="smk__question" data-view-heading tabindex="-1">${question.title}</h2>
      <p class="smk__sub">${escapeHtml(question.subtitle)}</p>
      <div class="${optionClasses}" role="group" aria-label="${escapeHtml(stripHtml(question.title))}">
        ${options}
      </div>
      ${question.multiple ? `<button class="smk__continue" type="button" data-continue ${canContinue ? "" : "disabled"}>${escapeHtml(continueCopy)}</button>` : ""}
    </div>`;
    stage.setAttribute("aria-busy", "false");
    bindQuestionEvents(question);
    focusHeading();
  }

  function startIfNeeded() {
    if (state.started) return;
    state.started = true;
    track("smaaktest_start", { surface: "smaaktest" });
  }

  function commitQuestion(question) {
    track("smaaktest_step", {
      surface: "smaaktest",
      step: state.step + 1,
      question: question.id,
      answer: selected(question).join(","),
    });
    if (state.step === questions.length - 1) {
      renderResult();
      return;
    }
    state.step += 1;
    renderQuestion();
  }

  function bindQuestionEvents(question) {
    stage.querySelector("[data-back]")?.addEventListener("click", () => {
      state.step = Math.max(0, state.step - 1);
      renderQuestion();
    });
    stage.querySelectorAll("[data-option]").forEach((button) => {
      button.addEventListener("click", () => {
        startIfNeeded();
        const id = button.dataset.option;
        if (question.multiple) {
          const current = selected(question);
          if (current.includes(id)) {
            state.answers[question.id] = current.filter((item) => item !== id);
          } else if (current.length < question.max) {
            state.answers[question.id] = [...current, id];
          } else {
            state.answers[question.id] = [...current.slice(1), id];
          }
          updateMultipleChoice(question);
          return;
        }
        state.answers[question.id] = [id];
        commitQuestion(question);
      });
    });
    stage.querySelector("[data-continue]")?.addEventListener("click", () => {
      if (selected(question).length >= (question.min || 1)) commitQuestion(question);
    });
  }

  function updateMultipleChoice(question) {
    const chosen = selected(question);
    stage.querySelectorAll("[data-option]").forEach((button) => {
      button.setAttribute("aria-pressed", String(chosen.includes(button.dataset.option)));
    });
    const continueButton = stage.querySelector("[data-continue]");
    if (!continueButton) return;
    continueButton.disabled = chosen.length < (question.min || 1);
    continueButton.textContent = chosen.length ? `Verder (${chosen.length} van ${question.max})` : "Kies één of twee smaken";
  }

  function alternativeCard(wine) {
    return `<a class="smk__alternative" href="${escapeHtml(wine.url)}" data-track-product data-placement="alternative" data-handle="${escapeHtml(wine.handle)}">
      <span class="smk__alternative-media">${productImage(wine, [260, 520], "(max-width: 760px) 70vw, 260px")}</span>
      <span class="smk__alternative-info">
        <span class="smk__alternative-maker">${escapeHtml(wine.vendor)}</span>
        <span class="smk__alternative-name">${escapeHtml(wine.title)}</span>
        <span class="smk__alternative-foot">
          <span class="smk__alternative-price">${escapeHtml(priceFormatter.format(wine.price))}</span>
          <span class="smk__alternative-cta">Bekijk wijn →</span>
        </span>
      </span>
    </a>`;
  }

  function renderResult() {
    state.result = rankWines();
    if (!state.result) {
      renderEmpty("We vonden nu geen beschikbare fles.", "Bekijk de actuele collectie; daar staat al het moois bij elkaar.");
      return;
    }
    const { match, alternatives } = state.result;
    const labels = profileLabels();
    const explanationLabels = labels.slice(0, 3).map((label) => label.toLowerCase());
    barTitle.textContent = "Jouw match";
    renderProgress(questions.length - 1, true);
    stage.innerHTML = `<div class="smk__view">
      <h2 class="smk__result-heading" data-view-heading tabindex="-1">Deze wijn past <em>bij jou.</em></h2>
      <div class="smk__profile" aria-label="Jouw smaakprofiel">${labels.map((label) => `<span>${escapeHtml(label)}</span>`).join("")}</div>
      <article class="smk__match">
        <a class="smk__match-media" href="${escapeHtml(match.url)}" data-track-product data-placement="main-image" data-handle="${escapeHtml(match.handle)}">
          <span class="smk__match-badge">Jouw beste match</span>
          ${productImage(match, [640, 960], "(max-width: 760px) 100vw, 46vw")}
        </a>
        <div class="smk__match-info">
          <p class="smk__maker">${escapeHtml(match.vendor)}</p>
          <h3 class="smk__wine-name"><a href="${escapeHtml(match.url)}" data-track-product data-placement="main-title" data-handle="${escapeHtml(match.handle)}">${escapeHtml(match.title)}</a></h3>
          <p class="smk__price">${escapeHtml(priceFormatter.format(match.price))}</p>
          <details class="smk__explain">
            <summary>Waarom dit jouw match is</summary>
            <p>Deze fles sluit het beste aan op je voorkeur voor ${escapeHtml(sentenceList(explanationLabels))}. We vergelijken je antwoorden met de actuele smaakomschrijving van de beschikbare wijnen.</p>
          </details>
          <div class="smk__actions">
            <a class="smk__button smk__button--primary" href="${escapeHtml(match.url)}" data-track-product data-placement="main-cta" data-handle="${escapeHtml(match.handle)}">Bekijk de wijn ${arrowIcon()}</a>
            <button class="smk__button smk__button--cart" type="button" data-add-cart data-variant="${escapeHtml(match.variantId)}" data-handle="${escapeHtml(match.handle)}">In winkelwagen</button>
          </div>
          <p class="smk__cart-status" data-cart-status aria-live="polite"></p>
          <p class="smk__promise">Direct van de wijnboer · Binnen 5–8 werkdagen in huis</p>
        </div>
      </article>
      ${alternatives.length ? `<h3 class="smk__alternatives-title">Ook raak gekozen</h3><div class="smk__alternatives">${alternatives.map(alternativeCard).join("")}</div>` : ""}
      <div class="smk__result-nav">
        <a class="smk__all-wines" href="${escapeHtml(root.dataset.collectionUrl)}">Bekijk alle wijnen</a>
        <button class="smk__restart" type="button" data-restart>Doe de test opnieuw</button>
      </div>
    </div>`;
    stage.setAttribute("aria-busy", "false");
    track("smaaktest_complete", {
      surface: "smaaktest",
      smaak_kleur: state.result.target.color,
      smaak_budget: state.result.target.budget,
      top_match: match.handle,
      top_match_name: match.title,
      match_price: match.price,
    });
    bindResultEvents(match);
    focusHeading();
  }

  function bindResultEvents(match) {
    stage.querySelectorAll("[data-track-product]").forEach((link) => {
      link.addEventListener("click", () => {
        track("smaaktest_result_view_product", {
          surface: "smaaktest",
          placement: link.dataset.placement,
          product_handle: link.dataset.handle,
        });
      });
    });
    stage.querySelector("[data-restart]")?.addEventListener("click", () => {
      track("smaaktest_restart", { surface: "smaaktest" });
      state.step = 0;
      state.answers = {};
      state.started = false;
      state.result = null;
      renderQuestion();
      root.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" });
    });
    stage.querySelector("[data-add-cart]")?.addEventListener("click", (event) => {
      addToCart(event.currentTarget, match);
    });
  }

  async function addToCart(button, wine) {
    const status = stage.querySelector("[data-cart-status]");
    const cartSurface = document.querySelector("cart-drawer, cart-notification");
    const sections = typeof cartSurface?.getSectionsToRender === "function" ? cartSurface.getSectionsToRender().map((section) => section.id) : [];
    button.disabled = true;
    button.textContent = "Toevoegen…";
    status.textContent = "";
    try {
      const response = await fetch(root.dataset.cartAddUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variant), quantity: 1 }],
          ...(sections.length ? { sections, sections_url: window.location.pathname } : {}),
        }),
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || "Cart error");
      button.textContent = "In winkelwagen ✓";
      status.textContent = "Toegevoegd. Je winkelmand is bijgewerkt.";
      track("smaaktest_add_to_cart", {
        surface: "smaaktest",
        product_handle: wine.handle,
        variant_id: wine.variantId,
        value: wine.price,
        currency: "EUR",
      });
      if (typeof cartSurface?.renderContents === "function") {
        cartSurface.renderContents(payload);
      } else if (typeof window.refreshCart === "function") {
        window.refreshCart();
      }

      const cartSidebar = document.getElementById("site-cart-sidebar");
      if (typeof cartSidebar?.show === "function") {
        cartSidebar.show();
      }
    } catch {
      button.disabled = false;
      button.textContent = "Opnieuw proberen";
      status.textContent = "Dat lukte niet. Bekijk de wijn om daar te bestellen.";
      return;
    }
    button.disabled = false;
  }

  function renderEmpty(title, copy) {
    barTitle.textContent = "Vind je wijn";
    progress.innerHTML = "";
    progress.removeAttribute("aria-valuenow");
    progress.setAttribute("aria-valuetext", "Niet beschikbaar");
    stage.innerHTML = `<div class="smk__empty">
      <h2 data-view-heading tabindex="-1">${escapeHtml(title)}</h2>
      <p>${escapeHtml(copy)}</p>
      <a class="smk__button smk__button--primary" href="${escapeHtml(root.dataset.collectionUrl)}">Bekijk alle wijnen ${arrowIcon()}</a>
    </div>`;
    stage.setAttribute("aria-busy", "false");
    focusHeading();
  }

  async function loadWines() {
    try {
      const response = await fetch(root.dataset.catalogUrl, {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      if (!response.ok) throw new Error("Catalog error");
      const payload = await response.json();
      state.wines = (payload.products || []).map(normalizeProduct).filter(Boolean);
      if (!state.wines.length) throw new Error("Empty catalog");
      renderQuestion();
    } catch {
      renderEmpty("De wijnkast wil even niet laden.", "Probeer het straks opnieuw of bekijk meteen alle beschikbare wijnen.");
    }
  }

  loadWines();
})();
